export default {
  'delegatedTasks.title': 'Tareas delegadas',
  'delegatedTasks.toolbarTitle': 'Tareas',
  'delegatedTasks.description': 'Consulta las tareas asociadas a esta configuración de delegación.',

  'delegatedTasks.form.status': 'Estado',
  'delegatedTasks.form.process': 'Proceso',
  'delegatedTasks.form.environment': 'Entorno',
  'delegatedTasks.form.processInstanceName': 'Nombre Solicitud',
  'delegatedTasks.form.name': 'Usuario delegado',
  'delegatedTasks.form.actionInstanceId': 'Paso de Ejecución',
  'delegatedTasks.form.created': 'Fecha de creación',

  'delegatedTasks.delegated': 'Delegado',
  'delegatedTasks.deleted': 'Removido',
};
